import React from 'react';
import PropTypes from 'prop-types';
import Thumbnail from './Thumbnail';

export default class ImageCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImageIndex: 0,
      currentPosition: 0,
      isVideoDisplayed: false,
    };
    this.onVideoSelected = this.onVideoSelected.bind(this);
  }
  onSelectedImageIndexChanged(newSelectedImageIndex) {
    this.setState({
      isVideoDisplayed: false,
      selectedImageIndex: newSelectedImageIndex,
    });
  }

  onMoveCarousel(direction) {
    const newCurrentPosition = this.state.currentPosition + direction;
    if (newCurrentPosition + this.props.maxCarouselSize > this.props.images.length || newCurrentPosition < 0) {
      return;
    }

    this.setState({
      currentPosition: newCurrentPosition,
    });
  }

  onVideoSelected() {
    this.setState({
      isVideoDisplayed: true,
    });
  }

  render() {
    return (
      <div className="images">
        <div className="thumbs-frame">
          <div className="col-thumbnail">
            {this.props.images.length > this.props.maxCarouselSize &&
              <div className="nav-up" onClick={() => this.onMoveCarousel(-1)} role="button" tabIndex={0}>
                <span className={`thumbnail-nav ${this.state.currentPosition > 0 ? '' : 'disabled'}`}>
                  <span className="icon icon-rs_22-chev-up" />
                </span>
              </div>
            }

            {(this.props.images.length > 1 ||
            (this.props.images.length === 1 && this.props.images[0].thumbnailURL)) &&
            this.props.images.slice(this.state.currentPosition, this.props.maxCarouselSize + this.state.currentPosition).map(image => (
              <Thumbnail
                image={image}
                key={image.id}
                index={image.id}
                selectedImageIndexChanged={newSelectedImage => { this.onSelectedImageIndexChanged(newSelectedImage); }}
                selectedImageIndex={this.state.selectedImageIndex}
              />),
            )}

            {this.props.images.length > this.props.maxCarouselSize &&
              <div className="nav-down" onClick={() => this.onMoveCarousel(1)} role="button" tabIndex={-1}>
                <span
                  className={`thumbnail-nav
                  ${this.state.currentPosition + this.props.maxCarouselSize !== this.props.images.length ? '' : 'disabled'}`}
                >
                  <span className="icon icon-rs_19-chev-down" />
                </span>
              </div>
            }

            {this.props.video.videoURL &&
            <div className="video-thumbnail-container" onClick={this.onVideoSelected} role="button" tabIndex={-1}>
              <span className="thumbnail-img video">
                <img className="video-thumbnail-image" src={this.props.video.thumbnailURL} alt="" />
              </span>
            </div>
            }

          </div>
        </div>
        <div className="col-enlarge">
          {!this.state.isVideoDisplayed &&
           this.props.images.length > 0 &&
           <img id="mainImage" src={this.props.images[this.state.selectedImageIndex].largeImageURL} alt="Main Product" />
          }
          {this.state.isVideoDisplayed &&
            <iframe
              title={this.props.video.videoURL}
              id={'mainVideo'}
              src={this.props.video.videoURL}
              frameBorder="0"
              wmode="opaque"
            />
          }
          { this.props.shared.isShared &&
            <div className="supporting-text">{this.props.shared.sharedMessage}</div>
          }
        </div>
        <div className="vfm-flags-images-container">
          { this.props.vfmFlagImages.map(({ id, imageURL, hoverText, imageName }) =>
            (<span key={id}>
              <img
                className="vfm-flags-image"
                src={imageURL}
                title={hoverText}
                alt={imageName}
              />
            </span>),
          )}
        </div>
      </div>
    );
  }
}
ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    thumbnailURL: PropTypes.string.isRequired,
    largeImageURL: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })).isRequired,
  maxCarouselSize: PropTypes.number.isRequired,
  shared: PropTypes.shape({
    isShared: PropTypes.bool.isRequired,
    sharedMessage: PropTypes.string.isRequired,
  }).isRequired,
  video: PropTypes.shape({
    thumbnailURL: PropTypes.string,
    videoURL: PropTypes.string,
  }).isRequired,
  vfmFlagImages: PropTypes.arrayOf(PropTypes.shape({
    imageURL: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
    hoverText: PropTypes.string.isRequired,
  })).isRequired,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/ImageCarousel/ImageCarousel.js